export const notificationConfig = {
  nzDuration: 3500,
  nzPlacement: 'top',
  nzPauseOnHover: true,
  nzMaxStack: 1,
};
